export default [
  {
    text: "苏州供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/苏州供电公司配网线路可开放容量.pdf",
  },
  {
    text: "苏州供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/苏州供电公司电网接入受限清单.pdf",
  },
  {
    text: "泰州电网受限接入配电线路清单",
    url: "/pdf/dianwangKkfyl/泰州电网受限接入配电线路清单.pdf",
  },
  {
    text: "泰州供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/泰州供电公司配网线路可开放容量.pdf",
  },
  {
    text: "徐州供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/徐州供电公司电网接入受限清单.pdf",
  },
  {
    text: "徐州供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/徐州供电公司配网线路可开放容量.pdf",
  },
  {
    text: "南通电网受限接入配电线路清单",
    url: "/pdf/dianwangKkfyl/南通电网受限接入配电线路清单.pdf",
  },
  {
    text: "盐城电网受限接入配电线路清单",
    url: "/pdf/dianwangKkfyl/盐城电网受限接入配电线路清单.pdf",
  },
  {
    text: "盐城供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/盐城供电公司配网线路可开放容量.pdf",
  },
  {
    text: "镇江电网受限接入配电线路清单",
    url: "/pdf/dianwangKkfyl/镇江电网受限接入配电线路清单.pdf",
  },
  {
    text: "淮安供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/淮安供电公司电网接入受限清单.pdf",
  },
  {
    text: "淮安供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/淮安供电公司配网线路可开放容量.pdf",
  },
  {
    text: "无锡供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/无锡供电公司电网接入受限清单.pdf",
  },
  {
    text: "无锡供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/无锡供电公司配网线路可开放容量.pdf",
  },
  {
    text: "宿迁供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/宿迁供电公司电网接入受限清单.pdf",
  },
  {
    text: "宿迁供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/宿迁供电公司配网线路可开放容量.pdf",
  },
  {
    text: "连云港供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/连云港供电公司电网接入受限清单.pdf",
  },
  {
    text: "连云港供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/连云港供电公司配网线路可开放容量.pdf",
  },
  {
    text: "扬州供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/扬州供电公司配网线路可开放容量.pdf",
  },
  {
    text: "南京供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/南京供电公司电网接入受限清单.pdf",
  },
  {
    text: "南京供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/南京供电公司配网线路可开放容量.pdf",
  },
  {
    text: "常州供电公司电网接入受限清单",
    url: "/pdf/dianwangKkfyl/常州供电公司电网接入受限清单.pdf",
  },
  {
    text: "常州供电公司配网线路可开放容量",
    url: "/pdf/dianwangKkfyl/常州供电公司配网线路可开放容量.pdf",
  },
];
